import React, { useEffect, useState } from "react";
import {
	TableContainer,
	AntdTable,
	ActionButton,
	AntdModal,
	CompaginationDiv,
	AntdInput,
} from "./styles";
import { Button } from "antd";
import moment from "moment";
import { CONSTANTS } from "../../../../utils/constants";
import { COLORS, Typo } from "../../../layout/theme";
import Main from "../../../layout/main/Main";
import { Link, useNavigate } from "react-router-dom";
import { get_import_orders_history } from "../../../../api/endpoints/orders";
import { useAuth } from "../../../../contexts/authContext";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

export default function HistoryImportOrders({ clientId }) {
	const { user } = useAuth();
	const navigate = useNavigate();
	const [data, setData] = useState(false);
	const [paginationInputValue, setPaginationInputValue] = useState(null);
	const [key, setKey] = useState(null);
	const [loading, setLoading] = useState(false);
	const [onlyWithErrors, setOnlyWithErrors] = useState(false);
	const [page, setPage] = useState(CONSTANTS.PAGE_LARGE_SIZE);
	const [actualPage, setActualPage] = useState(1);
	const [searchInfo, setSearchInfo] = useState(null);

	const fetch_history_imported_orders = async (pageToView) => {
		setLoading(true);
		const filters = {
			clientId: clientId,
			userId: user.uid,
			onlyWithErrors: onlyWithErrors,
			skip: pageToView,
			page: page,
		};
		const res = await get_import_orders_history(filters);
		setData(res.items);
		setSearchInfo(res?.paginationInfo);
		setLoading(false);
	};

	useEffect(() => {
		setActualPage(1);
		setPage(CONSTANTS.PAGE_LARGE_SIZE);
		fetch_history_imported_orders(1);
	}, []);

	const columns = [
		{
			title: () => <div style={{ color: COLORS.White }}>Fecha</div>,
			dataIndex: "created",
			render: (value, record) => (
				<div
					style={{
						color: record.failedItems > 0 ? COLORS.Danger : COLORS.DarkGrey,
						fontWeight: "600",
						cursor: record.failedItems > 0 ? "pointer" : "auto",
					}}
					onClick={() =>
						record.failedItems > 0 &&
						navigate(`/admin/importOrdersHistory/${record.id}`)
					}
				>
					{moment(value).format("DD-MM-YYYY HH:ss")}
				</div>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Usuario</div>,
			dataIndex: "user",
			render: (value, record) => (
				<div
					style={{
						color: record.failedItems > 0 ? COLORS.Danger : COLORS.DarkGrey,
						fontWeight: "600",
						cursor: record.failedItems > 0 ? "pointer" : "auto",
					}}
					onClick={() =>
						record.failedItems > 0 &&
						navigate(`/admin/importOrdersHistory/${record.id}`)
					}
				>
					{record.userFirstName + " " + record.userLastName}
				</div>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Cliente</div>,
			dataIndex: "clientName",
			render: (value, record) => (
				<div
					style={{
						color: record.failedItems > 0 ? COLORS.Danger : COLORS.DarkGrey,
						fontWeight: "600",
						cursor: record.failedItems > 0 ? "pointer" : "auto",
					}}
					onClick={() =>
						record.failedItems > 0 &&
						navigate(`/admin/importOrdersHistory/${record.id}`)
					}
				>
					{value}
				</div>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.White }}>Registros importados</div>
			),
			dataIndex: "totalItems",
			render: (value, record) => (
				<div
					style={{
						color: record.failedItems > 0 ? COLORS.Danger : COLORS.DarkGrey,
						fontWeight: "600",
						cursor: record.failedItems > 0 ? "pointer" : "auto",
					}}
					onClick={() =>
						record.failedItems > 0 &&
						navigate(`/admin/importOrdersHistory/${record.id}`)
					}
				>
					{value}
				</div>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.White }}>Registros importados OK</div>
			),
			dataIndex: "importedOKItems",
			render: (value, record) => (
				<div
					style={{
						color: record.failedItems > 0 ? COLORS.Danger : COLORS.DarkGrey,
						fontWeight: "600",
						cursor: record.failedItems > 0 ? "pointer" : "auto",
					}}
					onClick={() =>
						record.failedItems > 0 &&
						navigate(`/admin/importOrdersHistory/${record.id}`)
					}
				>
					{value}
				</div>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.White }}>Registros fallidos</div>
			),
			dataIndex: "failedItems",
			render: (value, record) => (
				<div
					style={{
						color: record.failedItems > 0 ? COLORS.Danger : COLORS.DarkGrey,
						fontWeight: "600",
						cursor: record.failedItems > 0 ? "pointer" : "auto",
					}}
					onClick={() =>
						record.failedItems > 0 &&
						navigate(`/admin/importOrdersHistory/${record.id}`)
					}
				>
					{value}
				</div>
			),
		},
	];

	const handleDecrement = () => {
		if (searchInfo.actualPage > 1) {
			const cp = searchInfo.actualPage - 1;
			fetch_history_imported_orders(cp);
			setActualPage(cp);
		}
	};

	const handleIncrement = () => {
		if (searchInfo.actualPage < searchInfo.totalPages) {
			const cp = searchInfo.actualPage + 1;
			fetch_history_imported_orders(cp);
			setActualPage(cp);
		}
	};

	const handlePageChange = (e) => {
		const selectedPage = parseInt(e.target.value);
		if (
			!isNaN(selectedPage) &&
			selectedPage >= 1 &&
			selectedPage <= searchInfo.totalPages
		) {
			fetch_history_imported_orders(selectedPage);
			setPaginationInputValue(selectedPage);
		} else {
			setPaginationInputValue(searchInfo.actualPage);
		}
	};

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						<Link to="/">Home</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>Historial</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>
			<Main.Body>
				<TableContainer>
					<AntdTable
						dataSource={data}
						columns={columns}
						loading={loading}
						pagination={false}
					/>
					{searchInfo && searchInfo.totalOrders > 0 && (
						<CompaginationDiv>
							{searchInfo.actualPage !== 1 && (
								<Button size="small" shape="circle" onClick={handleDecrement}>
									<LeftOutlined />
								</Button>
							)}
							<AntdInput
								step={1}
								min={1}
								max={searchInfo.totalPages}
								onPressEnter={(e) => handlePageChange(e)}
								onChange={(e) =>
									setPaginationInputValue(e.target.value.toString())
								}
								defaultValue={paginationInputValue.toString()}
								value={paginationInputValue.toString()}
								addonAfter={`/ ${searchInfo.totalPages}`}
								style={{
									width: ` ${searchInfo.totalPages > 99 ? "76px" : "66px"}`,
								}}
							/>
							{searchInfo.actualPage < searchInfo.totalPages && (
								<Button
									size="small"
									shape="circle"
									onClick={handleIncrement}
									disabled={
										searchInfo.actualPage === searchInfo.totalPages
											? true
											: false
									}
								>
									<RightOutlined />
								</Button>
							)}
						</CompaginationDiv>
					)}
				</TableContainer>
			</Main.Body>
		</Main>
	);
}
